import React from 'react';
import ReactDOM from 'react-dom';

import './css/index.css';

import { createStore, applyMiddleware } from 'redux';
import createHistory from 'history/createBrowserHistory';

import { routerMiddleware } from 'react-router-redux';

import App from './App';

import createSagaMiddleware from 'redux-saga';

import logger from 'redux-logger';

import * as sagas from './sagas/sagas';
import rootReducer from './reducers/rootReducer';
import * as userConstants from './constants/user';
// import registerServiceWorker from './registerServiceWorker';

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const routerMiddlewareInstance = routerMiddleware(history);

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Apply logger middleware if ENV is not production
const middleware = [sagaMiddleware, routerMiddlewareInstance];
if (process.env.NODE_ENV !== 'production') {
    middleware.push(logger);
}

const store = createStore(rootReducer, applyMiddleware(...middleware));

sagaMiddleware.run(sagas.rootSagas);

store.dispatch({ type: userConstants.FETCH_ME_REQUEST });

ReactDOM.render(
    <App store={store} history={history} />,
    document.getElementById('root'),
);

if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
        module.hot.accept('./App', () => {
            ReactDOM.render(
                <App store={store} history={history} />,
                document.getElementById('root'),
            );
        });
        module.hot.accept('./reducers/rootReducer', () => {
            store.replaceReducer(rootReducer);
        });
    }
}

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js